export const BOOKING_STATUS_COLORS: Record<string, string> = {
  pending: '#faad14',
  confirmed: '#1890ff',
  checked_in: '#52c41a',
  checked_out: '#bfbfbf',
  cancelled: '#8c8c8c',
  reserved: '#722ed1',
  blocked: '#d4380d',
  no_show: '#cf1322',
};

export const BOOKING_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  checked_in: 'Checked In',
  checked_out: 'Checked Out',
  cancelled: 'Cancelled',
  reserved: 'Reserved',
  blocked: 'Blocked',
  no_show: 'No Show',
};

export const BOOKING_STATUS_OPTIONS = Object.entries(BOOKING_STATUS_LABELS).map(
  ([value, label]) => ({ value, label })
);

export const ROOM_STATUS_COLORS: Record<string, string> = {
  available: '#52c41a',
  occupied: '#1890ff',
  reserved: '#722ed1',
  cleaning: '#faad14',
  maintenance: '#d4380d',
  blocked: '#d4380d',
  out_of_order: '#8c8c8c',
};

export const getBookingStatusColor = (status: string): string =>
  BOOKING_STATUS_COLORS[status] || '#bfbfbf';
